import { getIsSafari } from "constants/constants";

// Safari offset for svg elements
export const safariOffset = getSafariSvgOffset();
function getSafariSvgOffset() {
  const isSafari = getIsSafari();
  const SAFARI_OFFSET_TOP = 37;
  const safariOffset = isSafari ? SAFARI_OFFSET_TOP : 0;
  return safariOffset;
}
